var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    y: 9,
    width: 64,
    height: 53,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAB2HjRBAAAA80lEQVQokZWSLUuEQRRGj0ata9amGLQJm9aov0CwCRaDdpvFjRqWrQZhFyyC+AdMBj9AEBTEZFCD0SAGj8zLCOM476oPzNd95sxcZu6Qyj/UAJaAtQoJ8B/arNr1u55/A5fVkwTZU2/j/Gi4kPE00AbugR7QAh6AGeAFmIj7LtNbFtVDf6od/c3MWQjBXfW9AL2q8xHsZ96HOhaMHfUpMw/UkQieFQ6+qX4pSXtK3VJXkth5AQzaz+G0hf8/rQGDNsLe0msHjQPNAbVzEbo6eDSOx0An896Aq0EVtqo+Juv1JOXrr3gdPKk2sticeqduV2vlEx3v4C4R17ciAAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.dc2a32386057320230645629aea7a5a7.svg";
export { ForwardRef as ReactComponent };